import { forwardRef } from "react";
import { Drawer } from "antd";
import { getClassNames } from "@/shared/utils";
import type { DrawerProps, GetRef } from "antd";
import styles from "./styles.module.scss";

type DrawerRef = GetRef<typeof Drawer>;

export const AppDrawer = forwardRef<DrawerRef, DrawerProps>(({ className, ...props }, ref) => {
  return (
    <span ref={ref}>
      <Drawer {...props} className={getClassNames(styles.drawer, className)} />
    </span>
  );
});
